import { isAddressedInRoom } from '@common/helpers/arcAddress'
import { ARC_VOICE_ROOM_FOLLOW_UP_MS } from '@common/interfaces/arcVoice'

export { isAddressedInRoom }

/** A reply that ends on a question is waiting for an answer. */
export const isQuestion = (text: string): boolean => /\?["')\]]*\s*$/.test(text.trim())

/**
 * In a huddle Arc answers only what is said to it: a line that speaks to it ("Arc, …",
 * "Arc actually what…", "right, Arc?"), not one that merely mentions it, or the answer to
 * a question it just asked.
 */
export const shouldAnswerInRoom = (text: string, at: number, arcAskedAt: number | null): boolean =>
  isAddressedInRoom(text) || (arcAskedAt !== null && at - arcAskedAt <= ARC_VOICE_ROOM_FOLLOW_UP_MS)
